export function isCanvasProduct(product) {
	let flag = false
	for (let i=0; i < product.options.length; i++) {
		if (product.options[i]?.customFields?.uniqueTag) {
			flag = true
		}
	}
	return flag
}

function getSelectedOptionForAttribute(product, attributeCode) {
	if (!isCanvasProduct(product)) {
		return false;
	}

	let foundProp = product.properties.filter(property => {
		return property.group?.customFields?.attributeCode === attributeCode;
	});

	if (!foundProp || foundProp.length === 0) {
		return false;
	}

	return foundProp[0].id;
}

export function getSelectedCanvasOptions(product) {
	const customOptions = []
	for (let i=0; i < product.options.length; i++) {
		if (product.options[i]?.customFields?.uniqueTag) {
			customOptions.push(product.options[i].customFields.uniqueTag)
		}
	}

	return customOptions
}
